//
import { mapActions, mapState } from 'vuex'
import { CrudCreateButton } from '@/components/reusable_components'
import {
    ModelDataTable,
    ModelForm,
    VBtnAction,
} from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouseToList'
import BarAuthorizationModel from '@/models/Actions/ABarAuthorization'
import TranslatorService from '@/services/translator'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'transfer-between-warehouse-list',
    components: {
        'crud-create-button': CrudCreateButton,
        ModelDataTable,
        ModelForm,
        VBtnAction,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        //
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        formProps() {
            return {
                fields: [
                    {
                        name: 'auth_code',
                        type: 'text-field',
                        flex: {
                            xs12: true,
                        },
                        props: {
                            label: 'Código de autorización',
                            type: 'password',
                        },
                    },
                ],
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                service: TransferBetweenWarehouseModel,
                filters,
                headers,
                mapper: this.mapTransfers,
                paramFilter: {
                    has_special_reservation: '1',
                },
            }
        },
    },
    data() {
        return {
            dialog: false,
            formData: {
                auth_code: '',
                permission: 'access_to point_sale',
            },
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setAppToolbarItems: 'setAppToolbarItems',
        }),

        //
        ...mapActions('SnackbarModalModule', [
            'resetSnackbarState',
            'setMessageConfirmSnack',
            'setErrorSnackbar',
            'setWarningSnackbar',
            'setSuccessSnackbar',
        ]),

        /**
         *
         */
        mapTransfers(row) {
            //
            row.user = this.user
            //
            return row
        },

        /**
         *
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         *
         */
        close() {
            this.dialog = true
            this.resetSnackbarState()
        },

        /**
         *
         */
        confirm() {
            return this.selected.close().attach({
                supervisor_user_code: this.formData.auth_code,
                close_comment: this.formData.close_comment,
            })
        },

        /**
         *
         */
        deleteSelected() {
            this.selected
                .delete()
                .finally(this.resetSnackbarState)
                .then(this.success)
                .then(this.refresh)
                .catch(this.error)
        },

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(
                    TransferBetweenWarehouseModel,
                    error.response.data
                )
            )
        },

        /**
         *
         */
        errorAuthorization() {
            this.setErrorSnackbar('Código de autorización invalido.')
        },

        /**
         *
         */
        showPdf(res) {
            var fileURL = URL.createObjectURL(res.data)
            window.open(fileURL)
        },

        /**
         *
         */
        submitClose(event) {
            //
            this.setWarningSnackbar({
                title: '¿Deseas cerrar la guía de intercambio?',
                message: 'Una vez cerrada no se puede modificar.',
                confirm: 'confirmar',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitDialog() {
            this.$refs.form
                .setWait(true)
                .then(this.verify)
                .then(this.confirm)
                .catch(this.errorAuthorization)
                .then(this.successClose)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'transfer-between-warehouse-create' })
        },

        /**
         *
         */
        submitDelete(event) {
            //
            this.setWarningSnackbar({
                title: '¿Deseas eliminar la guía de intercambio?',
                message: 'Una vez eliminada no se puede recuperar.',
                confirm: 'eliminar item',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitDispatch(event) {
            this.$router.push({
                name: 'transfer-between-warehouse-dispatch',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitPdf(event) {
            event.item.pdf().then(this.showPdf)
        },

        /**
         *
         */
        submitReception(event) {
            this.$router.push({
                name: 'transfer-between-warehouse-reception',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'transfer-between-warehouse-update',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        success() {
            this.setSuccessSnackbar('Guía de intercambio eliminada.')
        },

        /**
         *
         */
        successClose() {
            this.setSuccessSnackbar('Guía de intercambio cerrada.')
            this.dialog = false
            this.refresh()
        },

        /**
         *
         */
        verify(data) {
            return new BarAuthorizationModel().params(data).get()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Guías de intercambio generadas por venta en terreno o call center')
        this.setAppToolbarItems({
            items: [
                {
                    action: this.submitCreate,
                    color: 'accent',
                    icon: 'add_circle',
                    text: 'crear guía de intercambio',
                    tip: 'Crear nueva guía de intercambio',
                    can: 'CREATE_TRANSFER_BETWEEN_WAREHOUSE',
                },
            ],
        })
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'eliminar item':
                    this.deleteSelected()
                    break
                case 'confirmar':
                    this.close()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_TRANSFER_BETWEEN_WAREHOUSE'))
                ctx.$router.push('/')
        })
    },
}
